import { makeAutoObservable} from "mobx";
class UserInfo{
    userInfo=null;
    constructor(){
        makeAutoObservable(this);
    }
    setUserInfo(obj){
        this.userInfo=JSON.stringify(obj);
    }
    getUserInfo(){
        return this.userInfo?JSON.parse(this.userInfo):{};
    }

}
const UserInfoStore=new UserInfo()
export default UserInfoStore;